var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCraftMaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 40,
    viewBox: "0 0 33 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7969 39.6889H16.3978V0L32.7969 39.6889Z",
    fill: "url(#paint0_linear_1133_12356)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 39.6889H16.3978V0L0 39.6889Z",
    fill: "url(#paint1_linear_1133_12356)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18841 19.8691L14.0792 27.6259L10.5785 30.6222H3.74573L8.18841 19.8691Z",
    fill: "url(#paint2_linear_1133_12356)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3978 30.6223L14.0792 27.626L10.5785 30.6223H16.3978Z",
    fill: "url(#paint3_linear_1133_12356)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0619 34.4887L0 39.6887L3.74575 30.6221L6.0619 34.4887Z",
    fill: "url(#paint4_linear_1133_12356)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.74573 30.6221L6.06188 34.4887L10.5785 30.6221H3.74573Z",
    fill: "url(#paint5_linear_1133_12356)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 39.6888L6.87336 35.8394L6.0619 34.4888L0 39.6888Z",
    fill: "url(#paint6_linear_1133_12356)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5785 30.6221H16.3978L6.87334 35.8394L6.06189 34.4887L10.5785 30.6221Z",
    fill: "url(#paint7_linear_1133_12356)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3979 30.6221L10.8605 39.6887L6.87341 35.8394L16.3979 30.6221Z",
    fill: "url(#paint8_linear_1133_12356)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 39.6887H10.8604L6.87336 35.8394L0 39.6887Z",
    fill: "url(#paint9_linear_1133_12356)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3978 30.6221L16.9076 30.9159L10.8605 39.6887L16.3978 30.6221Z",
    fill: "#90793F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9076 30.916L20.726 39.6889H10.8605L16.9076 30.916Z",
    fill: "url(#paint10_linear_1133_12356)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2857 35.5407L20.726 39.6889L16.9076 30.916L25.2857 35.5407Z",
    fill: "url(#paint11_linear_1133_12356)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2856 35.5405L32.7968 39.6887H20.726L25.2856 35.5405Z",
    fill: "url(#paint12_linear_1133_12356)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3978 30.6221L19.9404 28.7271L24.1147 32.2851L23.2847 34.4345L16.3978 30.6221Z",
    fill: "url(#paint13_linear_1133_12356)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1147 32.2852L32.7969 39.6889L23.2847 34.4345L24.1147 32.2852Z",
    fill: "url(#paint14_linear_1133_12356)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3978 30.6224L14.0792 27.6261L16.4076 25.6372L16.3978 30.6224Z",
    fill: "#B1995A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9404 28.727L26.7473 25.0566L24.1147 32.285L19.9404 28.727Z",
    fill: "url(#paint15_linear_1133_12356)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7472 25.0566L32.7968 39.6887L24.1146 32.285L26.7472 25.0566Z",
    fill: "url(#paint16_linear_1133_12356)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3991 24.3579L9.92468 18.0925L16.3991 2.42334L22.8747 18.09L16.3991 24.3579Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6143 18.7566V17.0393H17.8398C17.7647 17.3751 17.6748 17.6356 17.5714 17.8208C17.4679 18.006 17.33 18.1443 17.1564 18.2369C16.9828 18.3295 16.7587 18.3751 16.4841 18.3751C15.9447 18.3751 15.5359 18.106 15.2577 17.5677C14.9794 17.0295 14.8402 16.2369 14.8402 15.1912C14.8402 14.0653 14.9929 13.2159 15.2983 12.6443C15.6037 12.0727 16.0543 11.7862 16.6491 11.7862C16.9655 11.7862 17.2216 11.8875 17.4174 12.0899C17.6132 12.2924 17.7573 12.606 17.8472 13.0332H18.6155V11.3899C18.2806 11.2961 17.958 11.2282 17.6489 11.1862C17.3448 11.1455 17.0062 11.1245 16.6331 11.1245H16.6158C15.8659 11.1245 15.2219 11.2887 14.6826 11.6171C14.1433 11.9455 13.7357 12.4134 13.4587 13.0196C13.1816 13.6257 13.0437 14.3393 13.0437 15.1591C13.0437 16.0356 13.1619 16.7603 13.3971 17.3319C13.6323 17.9048 13.998 18.3319 14.493 18.6159C14.988 18.8986 15.6283 19.0406 16.4114 19.0406C16.7808 19.0406 17.1367 19.0171 17.4802 18.9727C17.8213 18.927 18.2006 18.8541 18.6143 18.7566Z",
    fill: "#CCAD6D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3978 30.6224L19.9404 28.7273L16.4077 25.6372L16.3978 30.6224Z",
    fill: "url(#paint17_linear_1133_12356)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7415 20.2001L23.2367 18.9668L16.4077 25.6384L17.3447 26.4569L22.7897 21.1285L28.215 34.2643L29.3528 33.7915L23.7415 20.2001Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06394 20.1901L9.56756 18.9556L16.4077 25.6383L15.4645 26.4408L10.0145 21.1185L4.59047 34.2531L3.45148 33.7815L9.06394 20.1901Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1133_12356",
    x1: 16.3984,
    y1: 19.8444,
    x2: 32.7969,
    y2: 19.8444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3A15F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1133_12356",
    x1: 7.71881,
    y1: 19.8444,
    x2: 17.008,
    y2: 19.8444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6B770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAE69A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1133_12356",
    x1: 2.41492,
    y1: 25.2123,
    x2: 11.5914,
    y2: 25.2883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8A763"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B26B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1133_12356",
    x1: 15.3698,
    y1: 29.2196,
    x2: 4.51733,
    y2: 27.9359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B7F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D8443"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1133_12356",
    x1: 1.03172,
    y1: 35.1556,
    x2: 6.44888,
    y2: 35.1556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC9F68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8A86A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1133_12356",
    x1: 3.74602,
    y1: 32.5558,
    x2: 10.5786,
    y2: 32.5558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8A763"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEC47E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1133_12356",
    x1: 0,
    y1: 37.0888,
    x2: 6.87285,
    y2: 37.0888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A6D32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94773B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1133_12356",
    x1: 6.06129,
    y1: 33.2309,
    x2: 16.3983,
    y2: 33.2309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92763A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1995A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1133_12356",
    x1: 6.87291,
    y1: 35.1556,
    x2: 16.3984,
    y2: 35.1556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94773B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B49D60"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1133_12356",
    x1: 0,
    y1: 37.7639,
    x2: 10.8604,
    y2: 37.7639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#866930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91783E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1133_12356",
    x1: 15.7929,
    y1: 39.666,
    x2: 15.7929,
    y2: 37.4717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C813D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0843D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1133_12356",
    x1: 16.9072,
    y1: 35.3021,
    x2: 25.286,
    y2: 35.3021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#897344"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#816B3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1133_12356",
    x1: 20.7253,
    y1: 37.6142,
    x2: 32.7968,
    y2: 37.6142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987E3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1133_12356",
    x1: 16.3984,
    y1: 31.581,
    x2: 24.1149,
    y2: 31.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0934B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C8344"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1133_12356",
    x1: 23.2852,
    y1: 35.9868,
    x2: 32.7969,
    y2: 35.9868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87703A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E5523"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1133_12356",
    x1: 20.0325,
    y1: 28.6708,
    x2: 26.8396,
    y2: 28.6708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4B574"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD9C5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1133_12356",
    x1: 24.1149,
    y1: 32.3727,
    x2: 32.7968,
    y2: 32.3727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC9D5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2904C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1133_12356",
    x1: 16.3984,
    y1: 28.1299,
    x2: 19.9402,
    y2: 28.1299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0944C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA8E46"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCraftMaster);
export default __webpack_public_path__ + "static/media/CraftMaster.e476c9ab9fd9f89cf788718af24e04d6.svg";
export { ForwardRef as ReactComponent };